import React from "react";

const PccProcedure = () => {
  return (
    <div className="pccExpContainer">
      <h2>
        Procedure for <span>PCC</span> Verification in Bangalore{" "}
      </h2>
      <p>
        The process of obtaining and verifying a PCC involves several steps.
        Goodway Attestation Services ensures that each step is meticulously
        followed to guarantee the authenticity and acceptance of your PCC
        abroad. The main steps in the PCC verification process include:
      </p>
      <ul>
        <li>
          <h3>
            <span>1.</span> Application Submission:
          </h3>{" "}
          The first step involves submitting the PCC application to the relevant
          police department or government agency.
        </li>
        <li>
          <h3>
            <span>2.</span> Background Check:
          </h3>{" "}
          The police department conducts a thorough background check to ensure
          that the applicant has no criminal record.
        </li>
        <li>
          <h3>
            <span>3.</span> Issuance of PCC:
          </h3>{" "}
          Once the background check is complete, the police department issues
          the PCC.
        </li>
        <li>
          <h3>
            {" "}
            <span>4.</span> Verification and Attestation:
          </h3>{" "}
          The PCC is then verified and attested by relevant authorities to
          confirm its authenticity for international use.
        </li>
      </ul>
    </div>
  );
};

export default PccProcedure;
